import React from "react";
import { Image } from "react-bootstrap";
import Button from "src/components/button";
import { Crop } from "src/components/editThumbnail/crop";

import styles from "./crop.module.scss";

interface IProfileCrop {
  image: any;
  toggleCrop: () => void;
  changeProfileImage: (image: string) => void;
}

const ProfileCrop: React.FC<IProfileCrop> = ({
  image,
  toggleCrop,
  changeProfileImage,
}) => {
  //states
  const [profileImage, setProfileImage] = React.useState(image);
  const [cropImage, setCropImage] = React.useState(false);
  const [cropValues, setCropValues] = React.useState({
    x: 0,
    y: 0,
    width: 0,
    height: 0,
  });

  //functions
  const handleCropImage = () => {
    const img = document.createElement("img");
    img.src = profileImage;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      canvas.width = cropValues.width;
      canvas.height = cropValues.height;

      if (ctx) {
        ctx.drawImage(
          img,
          cropValues.x,
          cropValues.y,
          cropValues.width,
          cropValues.height,
          0,
          0,
          cropValues.width,
          cropValues.height,
        );
      } else {
        console.error("Error: Canvas context is null");
      }
      const croppedImage = canvas.toDataURL("image/png");
      setProfileImage(croppedImage);
      setCropImage(false);
    };
    img.onerror = (err) => {
      console.error("Error loading image:", err);
    };
  };

  const handleProfileChange = () => {
    setProfileImage(profileImage);
    changeProfileImage(profileImage);
    toggleCrop();
  };

  //render
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>customize your image</h1>
        <span className={styles.subTitle}>
          pick your preferred profile picture.
        </span>
      </div>

      <div className={styles.imageContainer}>
        {!cropImage && <Image src={profileImage} className={styles.image} />}

        {cropImage && (
          <div className={styles.cropContainer}>
            <Crop
              className={styles.cropEditor}
              enabled={true}
              icon={profileImage}
              loading={false}
              onCrop={setCropValues}
              headerDimension={{
                height: 0,
                width: 0,
              }}
              cropperDimensions={{
                width: "15rem",
                height: "19.375rem",
              }}
            />
          </div>
        )}

        {!cropImage && (
          <div className={styles.imageActions}>
            <i
              className="paperflite-crop"
              onClick={() => {
                setCropImage(true);
              }}
            />
          </div>
        )}
      </div>

      <div className={styles.actions}>
        <Button
          text={cropImage ? "crop" : "save"}
          variant="primary"
          icon="paperflite-tick"
          onClick={cropImage ? handleCropImage : handleProfileChange}
        />
        <Button text="Cancel" onClick={() => {
          changeProfileImage(image)
          toggleCrop()
          }} />
      </div>
    </div>
  );
};

export default ProfileCrop;
